module.exports = __webpack_public_path__ + "img/The-Good-Gateway-Green-02.49c2611b.jpg";